module.exports = __webpack_public_path__ + "static/img/mylogo.4088e5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mylogo.png
// module id = CW+S
// module chunks = 12